// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Components
import ChangePasswordForm from '../../components/ForgotPassword/ChangePasswordForm';
import Loader from '../../components/Loader';
import NotFound from '../notFound/NotFound';
import { withQuery } from '../../hoc/withGraphql';

import s from './PasswordVerification.css';

const PasswordVerification = (props) => {

  const { email, token, title, encodeEmail } = props;
  const { data, data: { loading } } = props;
  let initialValues = { email: encodeEmail };
  if (loading) {
    return <Loader type={"text"} />
  }
  if (data && data.forgotPasswordVerification && data.forgotPasswordVerification.status === '200') {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <ChangePasswordForm initialValues={initialValues} />
        </div>
      </div>
    );
  } else {
    return <NotFound title={title} />
  }

}

PasswordVerification.propTypes = {
  email: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    forgotPasswordVerification: PropTypes.object
  })
};

export default compose(
  withStyles(s),
  withQuery(gql`
      query forgotPasswordVerification($email: String!, $token: String!) {
        forgotPasswordVerification (email: $email, token: $token) {
            id
            email
            token
            userId
            status
        }
      }`,
    {
      options: (props) => ({
        variables: {
          email: props.email,
          token: props.token,
        },
        ssr: false
      })
    }
  )
)(PasswordVerification);
